import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const rise = { y: 28 };
const fadeUp = { y: 28, opacity: 0 };

export function initAnimations() {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const heroBits = document.querySelectorAll('.hero__copy > *');
  if (heroBits.length) {
    gsap.from(heroBits, {
      ...rise,
      duration: 1.05,
      stagger: 0.12,
      ease: 'power3.out',
      delay: 0.12,
    });
  }

  if (document.querySelector('.hero__ring')) {
    gsap.set('.hero__ring', { xPercent: -50, yPercent: -50 });
    gsap.from('.hero__ring', {
      scale: 0.88,
      duration: 1.4,
      stagger: 0.12,
      ease: 'power2.out',
    });
    gsap.to('[data-float]', {
      y: 12,
      duration: 4.5,
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut',
      stagger: 0.4,
    });
  }

  if (document.querySelector('.command')) {
    gsap.from('.command', {
      y: 40,
      duration: 0.9,
      delay: 0.35,
      ease: 'power3.out',
    });
  }

  document.querySelectorAll('[data-reveal]').forEach((section) => {
    const items = [...section.children];
    if (!items.length) return;
    gsap.from(items, {
      ...fadeUp,
      duration: 0.85,
      stagger: 0.08,
      ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: {
        trigger: section,
        start: 'top 88%',
        once: true,
      },
    });
  });
}
